import React from "react";
import { Routes, Route, Navigate, BrowserRouter } from "react-router-dom";
import classNames from "classnames";
import { getHomePath, getCompaniesPath } from "./routes";
import { Home, Companies } from "../pages";
import { Navigation } from "../components/Navigation/Navigation";
import { Footer } from "../components/Footer/Footer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styles from "./styles.module.scss";

const RouterContent = () => {
  return (
    <div className={classNames(styles.Router, styles.fadeIn)}>
      <ToastContainer />
      <Navigation />
      <div className={styles.Content}>
        <Routes>
          <Route path={getHomePath()} element={<Home />} />
          <Route path={getCompaniesPath()} element={<Companies />} />
          <Route path="*" element={<Navigate replace to={getHomePath()} />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
};

export function Router() {
  return (
    <BrowserRouter>
      <RouterContent />
    </BrowserRouter>
  );
}
